/* Samba Street Co — native variant pricing for fabric and personalisation */
window.__SAMBA_NATIVE_PRICING_V2__ = true;
window.__sambaValenciaPilotLoaded = true;
document.documentElement.dataset.sambaNativePricing = 'loaded';

(() => {
  if (!document.body.classList.contains('template-product')) return;

  const CONFIG_NAMES = new Set([
    'Fan',
    'Fan + Personalisation',
    'Player',
    'Player + Personalisation',
  ]);
  const money = (cents) =>
    new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(cents / 100) + ' AUD';

  const optionPortal = () => document.querySelector('.easify.portal');
  const productForms = () => [...document.querySelectorAll('form[action^="/cart/add"]')];
  const primaryForm = () => productForms().find((form) => form.querySelector('.product-variant-id'));
  const personalisationToggle = () => {
    const toggles = [...document.querySelectorAll('button[class*="po-toggle"]')];
    return (
      toggles.find((toggle) =>
        /customi[sz]e\s+name|name\s*\+\s*number|name.*number/i.test(
          toggle.closest('.po-field-root')?.textContent || ''
        )
      ) || toggles[0] || null
    );
  };
  const personalisationInput = () => {
    const portal = optionPortal();
    if (!portal) return null;
    return (
      [...portal.querySelectorAll('input[type="text"], textarea')].find((input) =>
        /add your name and number|name\s*\+\s*number|name.*number/i.test(
          input.closest('.po-field-root')?.textContent || input.placeholder || ''
        )
      ) || null
    );
  };
  const personalisationActive = () => {
    const toggle = personalisationToggle();
    return !!(
      toggle &&
      (toggle.className.toString().includes('po-toggle-on') ||
        toggle.getAttribute('aria-checked') === 'true' ||
        toggle.getAttribute('aria-pressed') === 'true')
    );
  };
  const playerActive = () => {
    const hidden = document.querySelector('input[name="properties[Fabric Type]"]');
    if (hidden) return /^player(?:\s+version)?$/i.test(hidden.value.trim());
    const portal = optionPortal();
    if (!portal) return false;
    return [...portal.querySelectorAll('[class*="selected"], [aria-checked="true"], [aria-pressed="true"]')].some(
      (node) => /^player(?:\s+version)?$/i.test((node.textContent || '').trim())
    );
  };
  const configurationName = (supportsPlayer) => {
    const personalised = personalisationActive();
    const player = supportsPlayer && playerActive();
    if (player && personalised) return 'Player + Personalisation';
    if (player) return 'Player';
    if (personalised) return 'Fan + Personalisation';
    return 'Fan';
  };

  const ensureStyles = () => {
    if (document.getElementById('samba-native-pricing-styles')) return;
    const style = document.createElement('style');
    style.id = 'samba-native-pricing-styles';
    style.textContent = `
      .samba-option-surcharge {
        display: inline-flex;
        align-items: center;
        margin-left: .45rem;
        padding: .16rem .48rem;
        border-radius: 999px;
        background: rgba(0, 0, 0, .08);
        color: currentColor;
        font-size: .72em;
        font-weight: 700;
        letter-spacing: .02em;
        line-height: 1.2;
        white-space: nowrap;
        vertical-align: middle;
      }
      .po-switch-label + .samba-option-surcharge {
        margin-left: 0;
      }
      @media (max-width: 749px) {
        .samba-option-surcharge {
          padding: .14rem .4rem;
          font-size: .68em;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const prioritiseProductHeading = () => {
    const info = document.querySelector('.product__info-container');
    if (!info) return;
    const vendor = info.querySelector(':scope > .product__text');
    const title = info.querySelector(':scope > .product__title');
    const price = info.querySelector(':scope > [id^="price-"]');
    if (!title || !price) return;
    const headingNodes = [vendor, title, price].filter(Boolean);
    const firstContent = [...info.children].find((node) => !headingNodes.includes(node)) || null;
    const fragment = document.createDocumentFragment();
    headingNodes.forEach((node) => fragment.appendChild(node));
    info.insertBefore(fragment, firstContent);
  };

  const ensureSurchargeNotices = () => {
    const portal = optionPortal();
    if (!portal) return;

    const fabricField = [...portal.querySelectorAll('.po-field-root')].find((field) =>
      /fabric\s*type/i.test(field.textContent || '')
    );
    if (fabricField) {
      const playerLabel = [...fabricField.querySelectorAll('span')].find(
        (node) => node.textContent.trim() === 'Player' && !node.querySelector('.samba-option-surcharge')
      );
      if (playerLabel && !playerLabel.parentElement.querySelector('.samba-option-surcharge')) {
        playerLabel.insertAdjacentHTML(
          'afterend',
          '<span class="samba-option-surcharge">+$10 AUD</span>'
        );
      }
    }

    const toggle = personalisationToggle();
    const switchRoot = toggle?.closest('.po-switch-root');
    const switchLabel = switchRoot?.querySelector('.po-switch-label');
    if (switchLabel && !switchRoot.querySelector('.samba-option-surcharge')) {
      switchLabel.insertAdjacentHTML(
        'afterend',
        '<span class="samba-option-surcharge">+$10 AUD</span>'
      );
    }
  };

  const suppressUnsupportedPersonalisation = () => {
    if (document.documentElement.dataset.sambaPersonalisationAllowed !== 'false') return;
    const portal = optionPortal();
    if (!portal) return;

    [...portal.querySelectorAll('.po-field-root')].forEach((field) => {
      const text = field.textContent || '';
      if (!/customi[sz]e\s+name|name\s*\+\s*number|add your name and number|name.*number/i.test(text)) return;
      field.hidden = true;
      field.style.setProperty('display', 'none', 'important');
      field.querySelectorAll('input, textarea, select, button').forEach((control) => {
        control.disabled = true;
        control.removeAttribute('form');
      });
    });

    document.querySelectorAll('input[name^="properties["]').forEach((input) => {
      if (!/switch\s*nome|name|number/i.test(input.name || '')) return;
      input.disabled = true;
      input.removeAttribute('form');
    });
  };

  const enhanceUi = () => {
    ensureStyles();
    prioritiseProductHeading();
    suppressUnsupportedPersonalisation();
    ensureSurchargeNotices();
  };

  const removeLegacyUi = () => {
    document.querySelectorAll('.samba-configuration, .samba-options-total').forEach((node) => node.remove());
    document.querySelectorAll('.product-form__input').forEach((picker) => {
      if (/configuration/i.test(picker.querySelector('legend')?.textContent || '')) picker.hidden = true;
    });
    document.querySelectorAll('variant-selects').forEach((picker) => {
      if (/configuration/i.test(picker.textContent || '')) picker.hidden = true;
    });
    enhanceUi();
  };

  const updatePrice = (variant) => {
    const formatted = money(variant.price);
    document
      .querySelectorAll(
        '.product__info-container .price-item--regular, .product__info-container .price-item--sale, .samba-sticky-atc__product span'
      )
      .forEach((node) => {
        if (node.textContent.trim() !== formatted) node.textContent = formatted;
      });
  };

  const updateVariant = (variant) => {
    productForms().forEach((form) => {
      const input = form.querySelector('input[name="id"]');
      if (!input || input.value === String(variant.id)) return;
      input.value = String(variant.id);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    updatePrice(variant);
  };

  const ensureError = () => {
    const form = primaryForm();
    if (!form) return null;
    let error = form.querySelector('.samba-native-pricing__error');
    if (!error) {
      error = document.createElement('p');
      error.className = 'samba-native-pricing__error';
      error.setAttribute('role', 'alert');
      error.hidden = true;
      form.prepend(error);
    }
    return error;
  };

  const initialise = async () => {
    let product;
    try {
      const response = await fetch(`${location.pathname}.js`);
      if (!response.ok) return;
      product = await response.json();
    } catch (_) {
      return;
    }

    const tags = Array.isArray(product.tags) ? product.tags : [];
    const personalisationAllowed = !tags.some((tag) => /^no personalisation$/i.test(String(tag).trim()));
    document.documentElement.dataset.sambaPersonalisationAllowed = String(personalisationAllowed);

    const variants = product.variants.filter((variant) => CONFIG_NAMES.has(variant.title));
    removeLegacyUi();
    if (variants.length < 2) return;
    const supportsPlayer = variants.some((variant) => variant.title === 'Player');
    const byName = new Map(variants.map((variant) => [variant.title, variant]));
    document.documentElement.dataset.sambaNativePricing = 'ready';
    removeLegacyUi();
    enhanceUi();

    let syncing = false;
    let scheduled = 0;
    const sync = () => {
      window.clearTimeout(scheduled);
      scheduled = window.setTimeout(() => {
        if (syncing) return;
        const variant = byName.get(configurationName(supportsPlayer));
        if (!variant) return;
        document.documentElement.dataset.sambaPricingConfiguration = variant.title;
        syncing = true;
        updateVariant(variant);
        removeLegacyUi();
        requestAnimationFrame(() => {
          syncing = false;
        });
      }, 40);
    };

    document.addEventListener('click', (event) => {
      if (!event.target.closest('.easify.portal')) return;
      [0, 100, 350, 700].forEach((delay) => window.setTimeout(sync, delay));
    }, true);
    document.addEventListener('change', (event) => {
      if (event.target.closest('.easify.portal')) sync();
    }, true);
    document.addEventListener('input', (event) => {
      if (event.target.closest('.easify.portal')) sync();
    }, true);
    new MutationObserver(sync).observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'aria-checked', 'aria-pressed', 'value'],
      childList: true,
      subtree: true,
    });

    productForms().forEach((form) => {
      form.addEventListener(
        'submit',
        (event) => {
          sync();
          const error = ensureError();
          const input = personalisationInput();
          if (personalisationActive() && !input?.value.trim()) {
            event.preventDefault();
            if (error) {
              error.textContent = 'Enter the name and number before adding this personalised shirt to cart.';
              error.hidden = false;
            }
            input?.focus();
          } else if (error) {
            error.hidden = true;
          }
        },
        true
      );
    });

    sync();
  };

  const boot = () => {
    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (optionPortal() && primaryForm()) {
        window.clearInterval(timer);
        initialise();
      } else if (attempts >= 80) {
        window.clearInterval(timer);
      }
    }, 100);
  };

  boot();
})();
